import type { Timestamp } from 'firebase/firestore';

// ─── Tipos de acción rastreables ────────────────────────────

export type TipoAccionAuditoria =
  // Navegación
  | 'PAGE_VIEW'
  // Accesos
  | 'LOGIN'
  | 'LOGOUT'
  | 'SESSION_START'
  | 'SESSION_RESUME'
  // Acciones clínicas
  | 'CONSULTA_INICIADA'
  | 'CONSULTA_FINALIZADA'
  | 'PACIENTE_ASIGNADO'
  | 'PACIENTE_TRANSFERIDO'
  | 'NOTA_MEDICA_CREADA'
  | 'NOTA_MEDICA_EDITADA'
  // Acciones administrativas
  | 'SALA_CREADA'
  | 'SALA_EDITADA'
  | 'MEDICO_PREREGISTRADO'
  | 'MEDICO_EDITADO'
  | 'CONFIG_MODIFICADA'
  // Acciones de perfil
  | 'PERFIL_ACTUALIZADO'
  | 'AVATAR_CAMBIADO'
  // Genérica
  | 'ACCION_CUSTOM';

export type CategoriaAccion =
  | 'navegacion'
  | 'acceso'
  | 'clinica'
  | 'admin'
  | 'perfil'
  | 'otro';

// ─── Registro de auditoría de accesos ───────────────────────

export interface RegistroAcceso {
  id: string;
  /** UID de Firebase Auth del usuario */
  uid: string;
  /** Email del usuario */
  email: string;
  /** Rol al momento del registro */
  rol: string;
  /** Tipo de acción realizada */
  accion: TipoAccionAuditoria;
  /** Categoría de la acción */
  categoria: CategoriaAccion;
  /** Ruta/página visitada */
  pagina: string;
  /** Descripción legible de la acción */
  descripcion: string;
  /** Metadata adicional específica de la acción */
  detalles?: Record<string, unknown>;
  /** IP del cliente (si disponible) */
  ip?: string;
  /** User-Agent del navegador */
  userAgent?: string;
  /** Timestamp del servidor */
  creadoEn: Timestamp;
}

// ─── Helpers de categorización ──────────────────────────────

export const ACCION_CATEGORIA_MAP: Record<TipoAccionAuditoria, CategoriaAccion> = {
  PAGE_VIEW: 'navegacion',
  LOGIN: 'acceso',
  LOGOUT: 'acceso',
  SESSION_START: 'acceso',
  SESSION_RESUME: 'acceso',
  CONSULTA_INICIADA: 'clinica',
  CONSULTA_FINALIZADA: 'clinica',
  PACIENTE_ASIGNADO: 'clinica',
  PACIENTE_TRANSFERIDO: 'clinica',
  NOTA_MEDICA_CREADA: 'clinica',
  NOTA_MEDICA_EDITADA: 'clinica',
  SALA_CREADA: 'admin',
  SALA_EDITADA: 'admin',
  MEDICO_PREREGISTRADO: 'admin',
  MEDICO_EDITADO: 'admin',
  CONFIG_MODIFICADA: 'admin',
  PERFIL_ACTUALIZADO: 'perfil',
  AVATAR_CAMBIADO: 'perfil',
  ACCION_CUSTOM: 'otro',
};

export const CATEGORIA_LABELS: Record<CategoriaAccion, string> = {
  navegacion: 'Navegacion',
  acceso: 'Accesos',
  clinica: 'Clinica',
  admin: 'Administracion',
  perfil: 'Perfil',
  otro: 'Otros',
};
